import { useCallback, useEffect, useState } from 'react';
import { useInterval } from 'react-use';

import { devicesTestingApi } from 'client/api';
import { useFetchingHandler } from 'client/hooks/useFetchingHandler';
import { DevicesTestingStatusMeta } from 'client/model/devicesTestingForm';
import { SmartHome } from 'client/model/skill';

const POLLING_INTERVAL_MS = 1000 * 60;

export const useDevicesTestingStatus = (aliceApp: SmartHome) => {
    const [devicesTestingStatusMeta, setDevicesTestingStatusMeta] = useState<DevicesTestingStatusMeta>();

    const handler = useCallback(() => {
        return devicesTestingApi.getDevicesTestingRecordStatus(aliceApp.id, aliceApp.channel);
    }, [aliceApp.id, aliceApp.channel]);

    const [loadStatusHandler, fetchingState] = useFetchingHandler({ handler });

    const loadStatus = useCallback(async () => {
        setDevicesTestingStatusMeta(await loadStatusHandler());
    }, [loadStatusHandler]);

    const loadStatusUnhandled = useCallback(async () => {
        setDevicesTestingStatusMeta(await handler());
    }, [handler]);

    useEffect(() => {
        void loadStatus();
    }, [loadStatus]);
    useInterval(loadStatusUnhandled, POLLING_INTERVAL_MS);

    return { devicesTestingStatusMeta, loadStatusUnhandled, fetchingState };
};
